import { FC } from "react";
import { Dropdown, Menu, Space, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  loadTransportationAllData,
  loadTransportationAllItems,
} from "services/interface";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
interface TableShippingListProps {
  data: loadTransportationAllData | undefined;
  onDeleteConfigs: (geography_id: number, transport_type: string, province_id: number | null, district_id: number | null) => void;
}

const TableShippingList: FC<TableShippingListProps> = ({
  data,
  onDeleteConfigs,
}) => {
  const navigate = useNavigate();

  //sort data with transport_type
  const sortData = data?.data.sort((a, b) => {
    return a.transport_type.localeCompare(b.transport_type);
  });

  const columns: ColumnsType<loadTransportationAllItems> = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      align: "center",
      key: "index",
      render: (text, record, index) => {
        return <Typography.Link
        style={{cursor: "pointer"}}
        onClick={() => {
          navigate(
            `update/${record.geography_id}/${record.transport_type}/${record.province_id}/${record.district_id}/${record.is_free}`
          );
        }}
        >{index + 1}</Typography.Link>;
      },
      width: 50,
      
    },
    {
      title: "ประเภทการขนส่ง",
      dataIndex: "transport_name",
      render: (_text,record) => {
        return <Typography.Link
        style={{cursor: "pointer"}}
        onClick={() => {
          navigate(
            `update/${record.geography_id}/${record.transport_type}/${record.province_id}/${record.district_id}/${record.is_free}`
          );
        }}
        >{_text}</Typography.Link>;
      },
    },
    {
      title: "ภูมิภาค",
      dataIndex: "geography_name",
      align: "center",
      render: (_text, record) => {
        return <Typography.Link
        style={{cursor: "pointer"}} 
        onClick={() => {
          navigate(
            `update/${record.geography_id}/${record.transport_type}/${record.province_id}/${record.district_id}/${record.is_free}`
          );
        }}
        >{_text ?? 0}</Typography.Link>;
      },
    },

    {
      title: "จังหวัด-อำเภอ",
      dataIndex: "area_name",
      align: "center",
      render: (_text, record) => {
        return <Typography.Link
        style={{cursor: "pointer"}} 
        onClick={() => {
          navigate(
            `update/${record.geography_id}/${record.transport_type}/${record.province_id}/${record.district_id}/${record.is_free}`
          );
        }}
        >{_text ?? 0}</Typography.Link>;
      },
    },
   

    // {
    //   title: "ราคาที่สั่งซื้อ",
    //   dataIndex: "transport_rate",
    //   align: "center",
    //   render: (_text) => {
    //     return <Typography.Paragraph >{_text ?? 0}</Typography.Paragraph>;
    //   },
    // },
    // {
    //   title: "ค่าจัดส่งตามเงื่อนไข",
    //   dataIndex: "service_discount_price",
    //   align: "center",
    //   render: (_text) => {
    //     return <Typography.Paragraph >{_text ?? 0}</Typography.Paragraph>;
    //   },
    // },
    {
      title: "หมายเหตุ",
      dataIndex: "remark",
      key: "remark",
      render: (_text) => {
        return <Typography.Paragraph >{_text ?? ''}</Typography.Paragraph>;
      },
    },
    {
      title: "Action",
      dataIndex: "transection_code",
      align: "center",
      key: "transection_code",
      width: 100,
      render: (_text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Space size="middle">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      navigate(
                        `update/${record.geography_id}/${record.transport_type}/${record.province_id}/${record.district_id}/${record.is_free}`
                      );
                    }}
                  >
                    แก้ไข
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      onDeleteConfigs(
                        record.geography_id,
                        record.transport_type,
                        record.province_id || null,
                        record.district_id || null,
                      );
                    }}
                  >
                    ลบ
                  </Menu.Item>
                </Menu>
              }
            >
              <div>
                <EllipsisOutlined />
              </div>
            </Dropdown>
          </Space>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table columns={columns} dataSource={sortData} />
    </div>
  );
};

export default TableShippingList;
